function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-122 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 0.5px;\n      }\n\n      .cls-223 {\n        fill: #fff;\n      }\n\n      .cls-322 {\n        fill: #32b437;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic-xls",
  transform: "translate(-6 -6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10145",
  "data-name": "Path 10145",
  className: "cls-122",
  d: "M31.659,10H25V20.153h6.659a.392.392,0,0,0,.416-.363V10.363A.392.392,0,0,0,31.659,10Z",
  transform: "translate(-11.935 -2.513)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10146",
  "data-name": "Path 10146",
  className: "cls-223",
  d: "M27.6,15h2.6v1.116H27.6Zm0,3.719h2.6v1.116H27.6Zm0,1.859h2.6v1.116H27.6Zm0-3.719h2.6v1.116H27.6ZM25,15h1.859v1.116H25Zm0,3.719h1.859v1.116H25Zm0,1.859h1.859v1.116H25Zm0-3.719h1.859v1.116H25Z",
  transform: "translate(-11.935 -5.653)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10147",
  "data-name": "Path 10147",
  className: "cls-223",
  d: "M13.809,19.387,6,17.9V7.487L13.809,6Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10148",
  "data-name": "Path 10148",
  className: "cls-322",
  d: "M13.329,22.206l-.9-1.7a1.493,1.493,0,0,1-.106-.349h-.014a2.678,2.678,0,0,1-.12.364l-.9,1.681H9.9l1.659-2.6L10.036,17h1.427l.744,1.56a2.713,2.713,0,0,1,.156.438h.015c.029-.1.083-.253.163-.454L13.369,17h1.307l-1.561,2.58,1.6,2.625H13.329Z",
  transform: "translate(-2.447 -6.91)"
}));

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.39,
    height: 16.387,
    viewBox: "0 0 14.39 13.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5e22ed56.svg";
export { ForwardRef as ReactComponent };